import { FILE_TRANSFORMATION_GROUPS, REVIT_EXTENSIONS, VIDEO_EXTENSIONS } from 'utils/constants/CommonConstants';

export function getFileResourceTypeFromFileName(fileName) {
    if (!fileName) return 'unknown';

    const fileExtension = fileName.split('.').pop().toLowerCase();

    if (fileExtension === 'mp4' || fileExtension === 'webm' || fileExtension === 'ogg') {
        return 'video';
    } else if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'tif', 'tiff'].includes(fileExtension)) {
        return 'image';
    } else if (fileExtension === 'pdf') {
        return 'pdf';
    } else {
        return 'unknown';
    }
}

export function getAwsPresignedUrlResourceType(url) {
    if (!url) return 'unknown';
    const urlObject = new URL(url);
    const filenameWithExtension = urlObject.pathname.substring(urlObject.pathname.lastIndexOf('/') + 1);

    return getFileResourceTypeFromFileName(filenameWithExtension);
}

export const isRevitFile = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    return REVIT_EXTENSIONS.includes(extension ?? '');
};

export const canHaveTransformations = (fileType) => {
    return FILE_TRANSFORMATION_GROUPS.includes(fileType);
};

export const removeZipExtension = (filename) => {
    return filename.endsWith('.zip') ? filename.slice(0, -4) : filename;
};

export function extractFilePath(url) {
    const parsedUrl = new URL(url);
    const path = parsedUrl.pathname;
    return path.startsWith('/') ? path.slice(1) : path;
}

export const uploadTypes = {
    image: 'image/*',
    video: 'video/*',
    pdf: 'application/pdf',
};

export const downloadFileFromUrl = (url, fileName) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const getIsVideo = (url) => {
    return Boolean(url && VIDEO_EXTENSIONS.test(url));
};
